// Shared UI Components
import { ErrorView } from '@gif/shared-ui';
import { getLang } from '@gif/shared-global';
import { translate } from '../../configs';

// Copy
const acknowledgement = translate('tryReloadingPage');
const link = `https://www.mlb.com${
  getLang() === 'es' ? '/es' : ''
}/official-information/contact`;
const linkText = translate('troubleshoot');
const title = translate('pageNotLoading');
const buttonText = translate('reloadPage');

const reloadPage = () => {
  window.location.reload();
};

export const ErrorScreen = () => (
  <ErrorView
    title={title}
    onClick={reloadPage}
    buttonText={buttonText}
    url={link}
    urlText={linkText}
    message={acknowledgement}
  />
);

export default ErrorScreen;
